
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { post } from "../../services/ApiService";
import "../custom-style.css";
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from "react-router-dom";
import { loginSuccess } from "../../redux/Authentication";

const ChangePassword = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const user = useSelector((state) => state.user);

    const [passwordData, setPasswordData] = useState({
        current_password: "",
        new_password: "",
        confirm_password: "",
    });

    const handlePasswordInput = (e) => {
        const { name, value } = e.target;
        setPasswordData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            if (passwordData.new_password !== passwordData.confirm_password) {
                toast.error("New password and confirm password do not match");
                setIsLoading(false);
                return;
            }
            if (!user || !user._id) {
                 toast.error("User session invalid. Please login again.");
                 navigate('/login');
                 return;
            }

            const body = {
                currentPassword: passwordData.current_password,
                newPassword: passwordData.new_password
            }

            const res = await post(`api/auth/password/update/${user._id}`, body);

            if (res.success) {
                toast.success('Password updated successfully');
                // Update local storage and redux to reflect isNewUser: false
                const updatedUser = { ...user, isNewUser: false };
                dispatch(loginSuccess(updatedUser)); 
                
                setTimeout(() => {
                    navigate('/');
                }, 1000);
            } else {
                toast.error(res.error);
            }
        } catch (error) {
            console.log(error);
            toast.error('An error occurred. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

  return (
    <>
    <Toaster 
        position="top-center"
        reverseOrder={false}
    />
    <main id="content" className="wrapper layout-page">
        <section className="pb-lg-20 pb-16">
            <div className="container">
            <div className="text-center pt-13 mb-12 mb-lg-15">
                <div className="text-center">
                <h2 className="fs-36px mb-11 mb-lg-14">Change Password</h2>
                <p className="mb-0">You must change your password to continue.</p>
                </div>
            </div>
            <div className="row no-gutters">
                <div className="col-lg-10 mx-auto">
                <div className="row no-gutters justify-content-center">
                    <div className="col-lg-6 mb-15 mb-lg-0 pe-xl-2">
                    <form className onSubmit={handleSubmit}>
                        <div className="form-group mb-6">
                            <label className="visually-hidden">Current Password</label>
                            <input type="password" className="form-control" name="current_password" placeholder="Current Password" value={passwordData.current_password} onChange={handlePasswordInput} required/>
                        </div>
                        <div className="form-group mb-6">
                            <label className="visually-hidden">New Password</label>
                            <input type="password" className="form-control" name="new_password" placeholder="New Password" value={passwordData.new_password} onChange={handlePasswordInput} required/>
                        </div>
                        <div className="form-group mb-6">
                            <label className="visually-hidden">Confirm Password</label>
                            <input type="password" className="form-control" name="confirm_password" placeholder="Confirm Password" value={passwordData.confirm_password} onChange={handlePasswordInput} required/>
                        </div>
                        
                        <button type="submit" className="btn btn-primary w-100 mb-7" disabled={isLoading}>
                            {isLoading && <i className="fa fa-spinner fa-spin"></i>}  Update Password
                        </button>
                    </form>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </section>
    </main>
    </>
  )
}

export default ChangePassword
